// Import: Middleware Action & Custom Types
import {
  CLEAN_ASSIGMENTS_ORDER_CONFIRM_UPLOAD_DOCUMENT,
  CLEAN_ASSIGMENTS_ORDER_CONFIRM_UPLOAD_DOCUMENT_ERROR,
} from '_models/redux/types';

// Action function
export const cleanOrderAssignmentConfirmUploadDocument = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_ASSIGMENTS_ORDER_CONFIRM_UPLOAD_DOCUMENT,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_ASSIGMENTS_ORDER_CONFIRM_UPLOAD_DOCUMENT_ERROR,
    });
  }
};
